import React from "react"
import { withStyles } from '@material-ui/core';
import Selector from "./selector"
import Button from "storybookComponents/Button"
import { InsetLinkIcon } from 'icons'
import IconComponent from "components/IconComponent"
import VerticalMenu from "./menu"
import SaveReport from "./saveReports"

const styles = () => ({
  root: {
    height: 60,
    padding: "12px 20px",
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid #dadada"
  },
  select_root: {
    fontSize: 24,
    fontWeight: 400,
    fontFamily: "Open Sans",
    border: "none !important",
    paddingLeft: "0",
    lineHeight: "36px"
  },
  select_menu: {
    fontSize: 24,
    lineHeight: "36px",
    padding: "12px 20px"
  },
  buttonClass: {
    padding: "6px 16px",
    textTransform: "none",
    // marginRight: 16
  },
  rightPart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  linkCss: {
    marginRight: 16
  },
})


const selectOptions = [
  {
    label: 'By Property',
    id: "By Property"
  },
  {
    label: 'Campaign Analytics',
    id: "Campaign Analytics"
  },
  {
    label: 'hyRaf Contact List',
    id: "hyRaf Contact List"
  },
]


const Header = ({ classes, index, setSubMenu, hideSaveReport, reportData, showNotification, subOrgDetails }) => {
  const [open, setOpen] = React.useState(false);

  const handleChange = (e) => {
    setSubMenu(selectOptions.indexOf(e))
  }

  const handleToggle = () => {
    setOpen(!open)
  }

  return (
    <div className={classes.root}>
      <Selector
        options={selectOptions}
        value={selectOptions[index]}
        className={{
          select_root: classes.select_root,
          select_menu: classes.select_menu
        }}
        onChange={handleChange}
      />
      {
        hideSaveReport ? null :
          <div className={classes.rightPart}>
            <Button className={classes.buttonClass} onClick={handleToggle} variant="secondary">
              Save Dashboard
            </Button>
            {/* <IconComponent Component={InsetLinkIcon} className={classes.linkCss} onHoverColor="#26bbed" /> */}
            {/* <VerticalMenu reportData={reportData} showNotification={showNotification} subOrgDetails={subOrgDetails} /> */}
          </div>
      }
      <SaveReport
        open={open}
        handleToggle={handleToggle}
        reportData={reportData}
        showNotification={showNotification}
        subOrgDetails={subOrgDetails}
      />
    </div>
  )
}

export default withStyles(styles)(Header)